import type { GetAdminAccountPaymentSummaries200ItemAppGroupsItem } from './getAdminAccountPaymentSummaries200ItemAppGroupsItem';

export type GetAdminAccountPaymentSummaries200Item = {
  appGroups: GetAdminAccountPaymentSummaries200ItemAppGroupsItem[];
  userId: string;
};
